<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m16.5 5.19-1.057-1.058-2.138 2.408C11.76 4.8 9.623 3.75 7.207 3.75 5.04 3.75 3.053 4.62 1.5 6l1.065 1.065C3.84 5.947 5.452 5.25 7.208 5.25c2.054 0 3.817.945 5.077 2.43l-2.16 2.43-3-3L1.5 12.742l1.125 1.125 4.5-4.507 3 3 3.037-3.412a9.204 9.204 0 0 1 1.08 3.412h1.508a10.616 10.616 0 0 0-1.53-4.605L16.5 5.19Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
